import { getGlobalThat } from './global-that';

type DiTokenOptions<T> = {
  factory: () => T;
};

export class DiToken<T> {
  constructor(
    public name: string,
    public options?: DiTokenOptions<T>
  ) {}
}

export function clearDiStore(): void {
  const globalAny: any = getGlobalThat();
  globalAny['_diTokensStore'] = undefined;
}

function registerDiTokensStore(): void {
  const globalAny: any = getGlobalThat();
  if (!globalAny['_diTokensStore']) {
    globalAny['_diTokensStore'] = new Map();
  }
}

function getDiTokensStore<T>(): Map<string, T | undefined> {
  const globalAny: any = getGlobalThat();
  return globalAny['_diTokensStore'];
}

// Decision: see ADR-0005 — first registration wins and later ones are silently ignored, by design.
export function registerDiToken<T>(diToken: DiToken<T>, tokenValueFactory: () => T): void {
  registerDiTokensStore();
  const diStore: Map<string, T | undefined> = getDiTokensStore();
  if (!diStore.has(diToken.name)) {
    diStore.set(diToken.name, tokenValueFactory());
  }
}

export function provideDiTokenValue<T>(diToken: DiToken<T>): T {
  registerDiTokensStore();
  const diStore: Map<string, T | undefined> = getDiTokensStore();
  if (!diStore.has(diToken.name) && diToken.options?.factory) {
    return diToken.options.factory();
  }
  if (!diStore.has(diToken.name)) {
    throw new Error('provideDiTokenValue error, missing diToken: ' + diToken.name);
  }
  return diStore.get(diToken.name)!;
}

/** @deprecated remove soon */
export function provideDiTokenValueWithDefault<T>(diToken: DiToken<T>, defaultVAlue: T): T {
  registerDiTokensStore();
  const diStore: Map<string, T | undefined> = getDiTokensStore();
  if (!diStore.has(diToken.name)) {
    return defaultVAlue;
  }
  return diStore.get(diToken.name)!;
}
